import {lazy} from 'react';
import {Route, Routes} from 'react-router-dom';
import MessageApproval from '../pages/Dashboard/general/my_tasks/MessageApproval';
import SongFileReupload from '../pages/admin/CMS_OPS/VoiceArtist/onboard/SongFileReupload';
import DemoStingerAddScript from '../pages/admin/global-content/demo-stinger-fulfillment/DemoStingerAddScript';
import DemoStingerAddVoice from '../pages/admin/global-content/demo-stinger-fulfillment/DemoStingerAddVoice';
import OnboardStationDownloads from '../pages/admin/PartnerExperience/PSM/onboard/Shippings/Downloads';
import DemoStingerProductRep from '../pages/admin/global-content/demo-stinger-fulfillment/DemoStingerProductRep';
import WelcomeMail from '../pages/admin/PartnerExperience/PSM/onboard/WelcomeMail/WelcomeMail';
import UsersPrimaryContact from '../pages/admin/global-content/users/UsersPrimaryContact';
import TaskRedirect from '../pages/task/TaskRedirect';

const AlertFollowUps = lazy(
  () => import('../pages/admin/tasks/AlertFollowUpsTask'),
);

const AccountBrandingVerify = lazy(
  () =>
    import(
      '../pages/admin/CMS_OPS/Creative/account-branding/AccountBrandingVerify'
    ),
);
const OnboardRecording = lazy(
  () => import('../pages/admin/CMS_OPS/VoiceArtist/onboard/Recording'),
);
const AudioApproval = lazy(
  () => import('../pages/Dashboard/general/my_tasks/AudioApproval'),
);
const OnboardReRecording = lazy(
  () => import('../pages/admin/CMS_OPS/VoiceArtist/onboard/Re-Recording'),
);
const BaseScirptCreationTask = lazy(
  () => import('../pages/contacts/messages/base/BaseScriptCreationTask'),
);
const MessageScriptVerification = lazy(
  () => import('../pages/contacts/onboarding/MessageContentVerificationTask'),
);
const MessageScriptRevision = lazy(
  () => import('../pages/contacts/onboarding/MessageRevisionTask'),
);
const ProcessingFinalAudio = lazy(
  () =>
    import(
      '../pages/admin/PartnerExperience/PSS/onboard/AudioVerify/ProcessingFinalAudio'
    ),
);
const OnboardFinancialSummary = lazy(
  () => import('../pages/admin/BusinessMgmt/on_boarding/FinancialSummary'),
);
const OnboardVoiceArtistAssign = lazy(
  () =>
    import(
      '../pages/admin/CMS_OPS/Production/on_boarding/Assigning/VoiceArtistAssign'
    ),
);
const OnboardDemoToPartner = lazy(
  () => import('../pages/admin/CMS_OPS/DB_Mgmt/on_boarding/DemoToPartner'),
);
const OnboardMarketing = lazy(
  () => import('../pages/admin/Marketing/onboarding/OnboardMarketing'),
);
const OnboardHandoffMail = lazy(
  () => import('../pages/admin/NavigatonOperation/onboarding/HandoffMail'),
);
const OnboardRevDevSendOutreach = lazy(
  () =>
    import(
      '../pages/admin/PartnerExperience/PSM/onboard/Rev-dev/OnboardingRevDev'
    ),
);
const OnboardShipping = lazy(
  () =>
    import('../pages/admin/PartnerExperience/PSM/onboard/Shippings/Shipping'),
);

const MusicReviewPerQueueProceess = lazy(
  () =>
    import('../pages/music/music-review-pre-queue/MusicReviewPerQueueProceess'),
);

const MusicReviewReplaceSection = lazy(
  () =>
    import('../pages/music/music-review-pre-queue/MusicReviewReplaceSection'),
);

const MusicReviewView = lazy(
  () => import('../pages/admin/music-review/MusicReviewView'),
);

const FileReUploadProcess = lazy(
  () =>
    import('../pages/admin/PartnerExperience/PSM/onboard/FileReUploadProcess'),
);
const StationSyncTaskCmpt = lazy(
  () => import('../pages/admin/BusinessMgmt/on_boarding/StationSyncTask'),
);

const NameAccoutBrandingCmpt = lazy(
  () =>
    import(
      '../pages/admin/CMS_OPS/Creative/account-branding/NameAccoutBranding'
    ),
);
const TnnSupportReviewCmpt = lazy(
  () => import('../pages/admin/tnn-control/task/TnnSupportReview'),
);
const TnnPartnerDescription = lazy(
  () => import('../pages/admin/tnn-control/task/TnnPartnerDescription'),
);
const TnnPartnerDemographic = lazy(
  () => import('../pages/admin/tnn-control/task/TnnPartnerDemographic'),
);

const ReviewPartnerFinancialInformation = lazy(
  () =>
    import(
      '../pages/staff-landing-page/partner-list/FInancialInformation/ReviewPartnerFinancialInformationTask'
    ),
);
const VerifyUnsuspendedPartnerPaid = lazy(
  () =>
    import(
      '../pages/staff-landing-page/partner-list/FInancialInformation/VerifyUnsuspendedPartnerPaidTask'
    ),
);

export const taskMultiRoute = [
  {
    path: 'base-script-creation',
    component: BaseScirptCreationTask,
    slug: ['base-script-creation-pending'],
    title: 'Base Message Script Creation',
  },
  {
    path: 'recording',
    component: OnboardRecording,
    slug: [
      'event-recording-pending',
      'stinger-recording-pending',
      'on-demand-recording-pending',
      'base-recording-pending',
      'timed-recording-pending',
      'network-esm-recording-pending',
      'network-odm-recording-pending',
      'to-voice-over',
      'walkup-lineup-manual-recording-pending',
    ],
    title: 'TEXT TO AUDIO CONVERSION',
  },
  {
    path: 'recording-verification',
    component: ProcessingFinalAudio,
    slug: [
      'event-recording-verification-pending',
      'base-recording-verification-pending',
      'on-demand-recording-verification-pending',
      'stinger-recording-verification-pending',
      'timed-recording-verification-pending',
      'song-request-recording-verification-pending',
      'network-esm-recording-verification-pending',
      'network-odm-recording-verification-pending',
      'global-commercial-recording-verification-pending',
      'wristband-color-recording-verification-pending',
      'walkup-player-recording-verification-pending',
      'sponsor-recording-verification-pending',
      'tnn-campaign-schedule-recording-verification-pending',
      'tnn-campaign-recording-verification-pending',
      'walkup-lineup-recording-verification-pending',
      'walkup-lineup-manual-recording-verification-pending',
    ],
    title: 'RECORDING VERIFICATION',
  },
  {
    path: 're-recording',
    component: OnboardReRecording,
    slug: [
      'event-rerecording-pending',
      'base-rerecording-pending',
      'on-demand-rerecording-pending',
      'stinger-rerecording-pending',
      'timed-rerecording-pending',
      'partner-provides-file',
      'network-esm-rerecording-pending',
      'network-odm-rerecording-pending',
      'global-commercial-rerecording-pending',
      'wristband-color-rerecording-pending',
      'song-request-rerecording-pending',
      'walkup-player-rerecording-pending',
      'partner-re-upload',
      'to-voice-over-rerecording',
      'tnn-campaign-schedule-rerecording-pending',
      'tnn-campaign-rerecording-pending',
      'walkup-lineup-manual-rerecording-pending',
      'walkup-lineup-rerecording-pending',
    ],
    title: 'TEXT TO AUDIO CONVERSION RE-RECORDING',
  },
  {
    path: 'database-management',
    component: OnboardDemoToPartner,
    slug: ['database_management'],
    title: 'COMPLETE DATABASE TASKS', // this created when onboarding
  },
  {
    path: 'business-management',
    component: OnboardFinancialSummary,
    slug: ['business_management'],
    title: 'ONBOARD FINANCIAL SUMMARY', // this created when onboarding
  },
  {
    path: 'station-sync',
    component: StationSyncTaskCmpt,
    slug: ['ok_to_download'],
    title: 'ONBOARD STATION DOWNLOAD',
  },
  {
    path: 'marketing',
    component: OnboardMarketing,
    slug: ['marketing'],
    title: 'NEW ONBOARD MARKETING SESSION',
  },
  {
    path: 'product-representative',
    component: OnboardHandoffMail,
    slug: ['product_representative'],
    title: 'Send Welcome Email to New Partner',
  },
  {
    path: 'music-review-pre-queue',
    component: MusicReviewPerQueueProceess,
    slug: ['music-review-pre-queue'],
    title: 'Music Review Pre Queue',
  },
  {
    path: 'music-review-pre-queue-replace',
    component: MusicReviewReplaceSection,
    slug: ['music-review-pre-queue-replace'],
    title: 'Music Review Pre Queue Replace',
  },
  {
    path: 'message-verification',
    component: MessageApproval,
    slug: [
      'sponsor-content-review-to-copywriter',
      'verify-partner-provided-details',
      'partner-provides-details',
      'sent-to-copywriter',
      'sponsor-content-review',
      'verify-sponsor-provided-details',
      'no-details-sent-to-copywriter',
      'sponsor-no-details-provided',
      'sponsor-provides-detail-review',
    ],
    title: 'MESSAGE VERIFICATION',
  },
  {
    path: 'music-review-producer',
    component: MusicReviewView,
    slug: [
      'music-review-instrumental-producer-process',
      'music-review-producer-process',
    ],
    title: '',
  },
  {
    path: 'partner_success_manager',
    component: WelcomeMail,
    slug: ['partner_success_manager'],
    title: 'WELCOME CALL & MAIL',
  },
  {
    path: 'revdev_initial_outreach',
    component: OnboardRevDevSendOutreach,
    slug: ['revdev_initial_outreach'],
    title: 'REVDEV INITIAL OUTREACH',
  },
  {
    path: 'audio-verification',
    component: AudioApproval,
    slug: [
      'production-file-review',
      'sponsor-file-review',
      'verify-sponsor-provided-file',
      'verify-partner-provided-file',
      'sponsor-rejects-produced-file',
    ],
    title: 'Audio File Approval',
  },
  {
    path: 'account-branding',
    component: AccountBrandingVerify,
    slug: ['creative-account-branding'],
    title: 'ACCOUNT BRANDING UPDATE',
  },
  {
    path: 'demo-stinger-fulfilment',
    component: DemoStingerAddScript,
    slug: ['demo-stinger-fulfilment'],
    title: 'DEMO STINGER FULFILMENT',
  },
  {
    path: 'demo-stinger-voice',
    component: DemoStingerAddVoice,
    slug: ['demo-stinger-voice', 'demo-stinger-production', 'demo-stinger-nr'],
    title: 'Demo Stinger Fulfillment Voice Attachment',
  },
  {
    path: 'users-primary-contact-removed',
    component: UsersPrimaryContact,
    slug: ['users-primary-contact-removed'],
    title: 'Users Primary Contact Removed',
  },
  {
    path: 'users-primary-contact-added',
    component: UsersPrimaryContact,
    slug: ['users-primary-contact-added'],
    title: 'Users Primary Contact Added',
  },
  {
    path: 'tnn-participation-form-ready',
    component: TnnSupportReviewCmpt,
    slug: ['tnn-participation-form-ready'],
    title: 'TNN Participation Form',
  },
  {
    path: 'demo-stinger-product-rep',
    component: DemoStingerProductRep,
    slug: ['demo-stinger-product-rep'],
    title: 'Demo Stinger Fulfillment',
  },
  {
    path: 'name_account_branding',
    component: NameAccoutBrandingCmpt,
    slug: ['name_account_branding'],
    title: 'Onboard Name Account Branding',
  },
  {
    path: 'quality_issue',
    component: FileReUploadProcess,
    slug: ['quality_issue'],
    title: 'Quality issue',
  },
  {
    path: 'reupload-song-file',
    component: SongFileReupload,
    slug: ['song-request-uploaded-file-rejected'],
    title: 'REJECTED SONG REQUEST RE-UPLOAD',
  },
  {
    path: 'script-verification',
    component: MessageScriptVerification,
    slug: [
      'base-script-verification-pending',
      'stinger-script-verification-pending',
    ],
    title: 'Message Script Verification',
  },
  {
    path: 'device_installation',
    component: OnboardStationDownloads,
    slug: ['device_installation'],
    title: 'DOWNLOADS',
  },
  {
    path: 'assign_voice_artist',
    component: OnboardVoiceArtistAssign,
    slug: ['assign_voice_artist'],
    title: 'Voice Artist To A Partner',
  },
  {
    path: 'script-revision',
    component: MessageScriptRevision,
    slug: ['base-message-revisal', 'stinger-message-revisal'],
    title: 'Script Revision Details',
  },
  {
    path: 'complete-tnn-pif',
    component: TnnSupportReviewCmpt,
    slug: ['complete-tnn-pif'],
    title: 'Complete TNN PIF',
  },
  {
    path: 'no-numbers-received',
    component: TnnSupportReviewCmpt,
    slug: ['no-numbers-received'],
    title: 'No Numbers Received',
  },
  {
    path: 'generate-demographic-data-for-tnn-opt-in',
    component: TnnPartnerDemographic,
    slug: ['generate-demographic-data-for-tnn-opt-in'],
    title: 'Generate Demographic Data for TNN Opt-In',
  },
  {
    path: 'create-tnn-partner-description',
    component: TnnPartnerDescription,
    slug: ['create-tnn-partner-description'],
    title: 'Create TNN Partner Description',
  },
  {
    path: 'create-tnn-audio-demo',
    component: TnnPartnerDescription,
    slug: ['create-tnn-audio-demo'],
    title: 'Create TNN Audio Demo',
  },
  {
    path: 'create-tnn-partner-thumbnail',
    component: TnnPartnerDescription,
    slug: ['create-tnn-partner-thumbnail'],
    title: 'Create TNN Partner Thumbnail',
  },
  {
    path: 'alert-follow-up',
    component: AlertFollowUps,
    slug: ['alert-follow-up', 'alert-follow-up-first'],
    title: 'Alert Follow Ups',
  },
  {
    path: 'review-partner-financial-information',
    component: ReviewPartnerFinancialInformation,
    slug: ['review-partner-financial-information'],
    title: 'Review Partner Financial Information',
  },
  {
    path: 'verify-unsuspended-partner-has-paid',
    component: VerifyUnsuspendedPartnerPaid,
    slug: ['verify-unsuspended-partner-has-paid'],
    title: 'Verify Unsuspended Partner Has Paid',
  },

  // add more routes, if all done below TaskRoutes no need
];

export default function TaskRoutes() {
  const primaryContactPaths = [
    'users-primary-contact-added',
    'users-primary-contact-removed',
  ];
  return (
    <Routes>
      {/* Legacy route redirects */}
      {taskMultiRoute.map(route => (
        <Route key={route.path} path={route.path} element={<TaskRedirect />} />
      ))}

      {/* Shipping */}
      <Route path='shipping' element={<OnboardShipping />} />
      {primaryContactPaths.map(path => (
        <Route key={path} path={path} element={<UsersPrimaryContact />} />
      ))}
    </Routes>
  );
}
